import Segments from './Segments';

export default Segments;
